import React from 'react';
import { ariaTabId, ariaPanelId } from '~/components/tab-group/tab-group';
export default function ContentGroup({ activeIndex, labels, children }) {
    return (React.createElement("div", { className: "content-group" }, React.Children.map(children, (child, i) => (React.createElement(Panel, { label: labels[i], key: i, active: activeIndex === i }, child)))));
}
function Panel({ label, active, children }) {
    const id = ariaPanelId(label);
    const tabId = ariaTabId(label);
    return (React.createElement("div", { id: id, "aria-labelledby": tabId, hidden: !active, role: "tabpanel" }, children));
}
